import * as React from 'react';
import {Link} from 'react-router-dom'

import {
  AppBar,
  Avatar,
  Box,
  Button,
  Menu,
  Toolbar,
  IconButton,
  Typography,
  Tooltip,
  MenuItem
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux'

import AdbIcon from '@mui/icons-material/Adb';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { logout } from '../../slices/auth'

const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function ResponsiveAppBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = (e) => {
    dispatch(logout());
    navigate('/');
  }

  return (
    <AppBar position="static" sx={{ paddingX: '24px', background: 'white', color: '#2A3547', boxShadow: 'rgba(0, 0, 0, 0.05) 0px 9px 17.5px'}}>
      <Toolbar disableGutters>
        <Box
          component="a"
          href="/chat"
          sx={{
            mr: 2,
            display: { xs: 'none', md: 'flex' },
            alignItems: 'center',
            gap: 0.5,
            textDecoration: 'none',
            cursor: 'pointer',
            color: 'inherit',
            '&:hover': { textDecoration: 'none' },
          }}
        >
          <AdbIcon sx={{ fontSize: '1.5rem', display: 'block' }} />
          <Typography
            noWrap
            sx={{
              fontFamily: 'monospace',
              fontWeight: 600,
              fontSize: '0.95rem',
              letterSpacing: 0,
              lineHeight: 1,
              color: 'inherit',
            }}
          >
            AnalyticsChat
          </Typography>
        </Box>

        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
          <Button
            component={Link}
            to='/chat'
            sx={{ my: 2, color: 'white', display: 'block', textTransform: 'none', color: '#2A3547' }}
          >
            Chat
          </Button>
          <Button
            component={Link}
            to='/presentation'
            sx={{ my: 2, color: 'white', display: 'block', textTransform: 'none', color: '#2A3547' }}
          >
            Presentation
          </Button>
          <Button
            component={Link}
            to='/visualization'
            sx={{ my: 2, color: 'white', display: 'block', textTransform: 'none', color: '#2A3547' }}
          >
            Visualization
          </Button>
          <Button
            component={Link}
            to='/financial-comparison'
            sx={{ my: 2, display: 'block', textTransform: 'none', color: '#2A3547' }}
          >
            Financial Comparison
          </Button>
          {/* <Button
            component={Link}
            to='/forecast'
            sx={{ my: 2, color: 'white', display: 'block', textTransform: 'none', color: '#2A3547' }}
          >
            Forecast
          </Button>
          <Button
            component={Link}
            to='/sql-generator'
            sx={{ my: 2, color: 'white', display: 'block', textTransform: 'none', color: '#2A3547' }}
          >
            SQL Generator
          </Button> */}
        </Box>
        <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="Notifications">
            <IconButton sx={{ p: 1 }}>
              <NotificationsActiveOutlinedIcon/>
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{ flexGrow: 0, marginLeft: 1 }}>
          <Tooltip title="Settings">
            <IconButton sx={{ p: 1 }} onClick={() => navigate('/settings')}>
              <SettingsOutlinedIcon/>
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{ flexGrow: 0, marginLeft: 2 }}>
          <Tooltip title="Open settings">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <MenuItem onClick={handleLogout}>
              <Typography textAlign="center">Logout</Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
export default ResponsiveAppBar;